// @ts-check

import React from "react";
import { useNavigate } from "react-router-dom";
import { BlockStack, Button, Card, Text } from "@shopify/polaris";
import { usePostHog } from "posthog-js/react";

import { useGlobalContext } from "context/GlobalContext";

import "./DashboardLockedCard.css";

export const DashboardLockedCard = () => {
  const { store } = useGlobalContext();
  const posthog = usePostHog();
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    posthog.capture("in-app-upgrade-button-clicked");
    navigate("/settings/plans");
  };

  let limitText = "";
  if (store?.subscription?.orders_per_month) {
    limitText = ` of ${store.subscription.orders_per_month} orders`;
  }

  return (
    <div className="locked-dashboard-card">
      <Card>
        <BlockStack gap="600">
          <BlockStack gap="200">
            <Text as="h2" variant="headingMd" alignment="center">Locked</Text>

            <Text as="p" variant="bodyMd" alignment="center">
              You have gone over the order limit{limitText} for your plan. Upgrade to unlock your account.
            </Text>
          </BlockStack>

          <Button onClick={handleUpgradeClick} variant="primary">
            Upgrade now
          </Button>
        </BlockStack>
      </Card>
    </div>
  );
};
